import Vue from 'vue'
import App from './App.vue'


//import './plugins/bootstrap-vue'
import BootstrapVue from 'bootstrap-vue'
// import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueRouter from 'vue-router'

import axios from 'axios'
import VueAxios from 'vue-axios'

//import resumablejs from 'resumablejs'

import StarRating from 'vue-star-rating'

import {
    NAMESPACE,
    ROUTERPATH
} from './config.js'



import Login from '@/components/Login'
import LoginUtenti from '@/components/LoginUtenti'
import LoginFromApp from '@/components/LoginFromApp'
import PageNotFound from '@/components/PageNotFound'
import PageAccessDenied from '@/components/PageAccessDenied'
import Logout from '@/components/Logout'
import Menu from '@/components/Menu'
import Dashboard from '@/components/Dashboard'
import Categorie from '@/components/Categorie'
import Convenzioni from '@/components/Convenzioni'
import Eventi from '@/components/Eventi'
import PrenotazioniPEStorico from '@/components/PrenotazioniPEStorico'
import Pagamenti from '@/components/Pagamenti'
import Sconti from '@/components/Sconti'
import Documenti from '@/components/Documenti'
import Questionari from '@/components/Questionari'
import Impianti from '@/components/Impianti'
//import Autoiscrizione from '@/components/Autoiscrizione'
//import CalendarioImpianto from '@/components/CalendarioImpianto'
import Abbonamenti from '@/components/Abbonamenti'
import TipiAbbonamento from '@/components/TipiAbbonamento'
import Risposte from '@/components/Risposte'
import Tipologie from '@/components/Tipologie'
import Soci from '@/components/Soci'
import Voti from '@/components/Voti'
import Allegati from '@/components/Allegati'
import Partecipa from '@/components/Partecipa'
import Orari from '@/components/Orari'
import Prenotazioni from '@/components/Prenotazioni'
import DettaglioCategoria from '@/components/DettaglioCategoria'
import DettaglioConvenzione from '@/components/DettaglioConvenzione'
import DettaglioEvento from '@/components/DettaglioEvento'
import DettaglioImpianto from '@/components/DettaglioImpianto'
import DettaglioVoto from '@/components/DettaglioVoto'
import DettaglioSocio from '@/components/DettaglioSocio'
import DettaglioPartecipa from '@/components/DettaglioPartecipa'
import DettaglioPrenotazioneEvento from '@/components/DettaglioPrenotazioneEvento'
import DettaglioPrenotazioneImpianto from '@/components/DettaglioPrenotazioneImpianto'
import DettaglioPagamento from '@/components/DettaglioPagamento'
import DettaglioSconto from '@/components/DettaglioSconto'
import DettaglioDocumento from '@/components/DettaglioDocumento'
import DettaglioModulistica from '@/components/DettaglioModulistica'
import TestataQuestionario from '@/components/TestataQuestionario'
import DettaglioQuestionario from '@/components/DettaglioQuestionario'
import DettaglioRisposta from '@/components/DettaglioRisposta'
import DettaglioDomanda from '@/components/DettaglioDomanda'
import DettaglioTipologia from '@/components/DettaglioTipologia'
import DettaglioTipoAbbonamento from '@/components/DettaglioTipoAbbonamento'
import DettaglioAbbonamento from '@/components/DettaglioAbbonamento'
import DettaglioOrario from '@/components/DettaglioOrario'
import DettaglioParente from '@/components/DettaglioParente'
import DettaglioBacheca from '@/components/DettaglioBacheca'
import DettaglioNews from '@/components/DettaglioNews'
import DettaglioSondaggioOpzione from '@/components/DettaglioSondaggioOpzione'

import AnalisiRisultati from '@/components/AnalisiRisultati'
import Storico from '@/components/Storico'
import Parenti from '@/components/Parenti'

import SondaggioOpzioni from '@/components/SondaggioOpzioni'
import SondaggioRisposte from '@/components/SondaggioRisposte'
import Push from '@/components/Push'
import News from '@/components/News'
import Bacheca from '@/components/Bacheca'
import Modulistica from '@/components/Modulistica'
import Parametri from '@/components/Parametri'

import LogoutUte from '@/components/utenti/LogoutUte'
import MenuUte from '@/components/utenti/MenuUte'



Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(VueAxios, axios)

//Vue.use(resumablejs)

Vue.component('star-rating', StarRating);

Vue.config.productionTip = false

const router = new VueRouter({
    mode: 'hash',
    //mode: 'history',
    //base: '/view/',
    //base: '/cctest/view/',
    //base: '',
    base: ROUTERPATH,
    routes: [{
            path: '/',
            name: 'Login',
            component: Login
        },
        {
            path: '/loginutenti',
            name: 'LoginUtenti',
            component: LoginUtenti
        },
        {
            path: '/loginfromapp/utente/:utente/token/:token/page/:page/paramb64/:paramb64',
            name: 'LoginFromApp',
            component: LoginFromApp
        },
        {
            path: '/loginfromapp/utente/:utente/token/:token/page/:page',
            name: 'LoginFromApp2',
            component: LoginFromApp
        },
        // {
        //     path: '/autoiscrizione/:appname', //tenuto per retrocompatibilità
        //     name: 'Autoiscrizione2',
        //     component: Autoiscrizione
        // },
        // {
        //     path: '/autoiscrizione',
        //     name: 'Autoiscrizione',
        //     component: Autoiscrizione
        // },
        {
            path: '/accessdenied',
            component: PageAccessDenied
        },
        {
            path: '/pagenotfound',
            component: PageNotFound
        },
        {
            path: '/ute',
            name: 'Ute',
            component: MenuUte,
            children: [
                {
                    path: 'logout',
                    name: 'LogoutUte',
                    component: LogoutUte
                },

            ]
        },
        {
            path: '/app',
            name: 'App',
            component: Menu,
            children: [{
                    path: '/',
                    name: 'Dashboard',
                    component: Dashboard
                },
                {
                    path: 'logout',
                    name: 'Logout',
                    component: Logout
                },
                {
                    path: 'allegati/id/:id/tipo/:tipo',
                    name: 'Allegati',
                    component: Allegati
                },
                {
                    path: 'voti/id/:id/tipo/:tipo',
                    name: 'Voti',
                    component: Voti
                },
                {
                    path: 'orari/id/:id/tipo/:tipo',
                    name: 'Orari',
                    component: Orari
                },
                {
                    path: 'categorie',
                    name: 'Categorie',
                    component: Categorie
                },
                {
                    path: 'convenzioni',
                    name: 'Convenzioni',
                    component: Convenzioni
                },
                {
                    path: 'prenotazionipestorico',
                    name: 'PrenotazioniPEStorico',
                    component: PrenotazioniPEStorico
                },
                {
                    path: 'prenotazionipestorico/id_evento/:id_evento',
                    name: 'PrenotazioniPEStorico3',
                    component: PrenotazioniPEStorico
                },
                {
                    path: 'prenotazionipestorico/id_evento/:id_evento/filter/:filter/datainizio/:datainizio/datafine/:datafine',
                    name: 'PrenotazioniPEStorico1',
                    component: PrenotazioniPEStorico
                },
                {
                    path: 'prenotazionipestorico/id_evento/:id_evento/datainizio/:datainizio/datafine/:datafine',
                    name: 'PrenotazioniPEStorico2',
                    component: PrenotazioniPEStorico
                },
                {
                    path: 'eventi',
                    name: 'Eventi',
                    component: Eventi
                },
                {
                    path: 'eventi/filter/:filter/datainizio/:datainizio/datafine/:datafine',
                    name: 'Eventi2',
                    component: Eventi
                },
                {
                    path: 'eventi/datainizio/:datainizio/datafine/:datafine',
                    name: 'Eventi1',
                    component: Eventi
                },
                {
                    path: 'soci',
                    name: 'Soci',
                    component: Soci
                },
                {
                    path: 'soci/flgatt/:flgatt/flgsocio/:flgsocio',
                    name: 'Soci2',
                    component: Soci
                },
                {
                    path: 'soci/filter/:filter/flgatt/:flgatt/flgsocio/:flgsocio',
                    name: 'Soci1',
                    component: Soci
                },
                {
                    path: 'sconti',
                    name: 'Sconti',
                    component: Sconti
                },
                {
                    path: 'sconti/id/:id',
                    name: 'Sconti2',
                    component: Sconti
                },
                {
                    path: 'sconti/id_scheda/:id_scheda/tipo/:tipo',
                    name: 'Sconti1',
                    component: Sconti
                },
                {
                    path: 'modulistica',
                    name: 'Modulistica',
                    component: Modulistica
                },
                {
                    path: 'documenti',
                    name: 'Documenti',
                    component: Documenti
                },
                {
                    path: 'documenti/id_socio/:id_socio',
                    name: 'Documenti1',
                    component: Documenti
                },
                {
                    path: 'questionari',
                    name: 'Questionari',
                    component: Questionari
                },
                {
                    path: 'impianti',
                    name: 'Impianti',
                    component: Impianti
                },
                {
                    path: 'impianti/filter/:filter/datainizio/:datainizio/datafine/:datafine',
                    name: 'Impianti2',
                    component: Impianti
                },
                {
                    path: 'impianti/datainizio/:datainizio/datafine/:datafine',
                    name: 'Impianti1',
                    component: Impianti
                },
                {
                    path: 'abbonamenti',
                    name: 'Abbonamenti',
                    component: Abbonamenti
                },
                {
                    path: 'abbonamenti/id_socio/:id_socio',
                    name: 'Abbonamenti1',
                    component: Abbonamenti
                },
                {
                    path: 'tipiabbonamento',
                    name: 'TipiAbbonamento',
                    component: TipiAbbonamento
                },
                {
                    path: 'dettagliotipoabbonamento',
                    name: 'DettaglioTipoAbbonamento',
                    component: DettaglioTipoAbbonamento
                },
                {
                    path: 'dettagliotipoabbonamento/:id',
                    name: 'DettaglioTipoAbbonamento1',
                    component: DettaglioTipoAbbonamento
                },
                {
                    path: 'dettaglioabbonamento',
                    name: 'DettaglioAbbonamento',
                    component: DettaglioAbbonamento
                },
                {
                    path: 'dettaglioabbonamento/:id',
                    name: 'DettaglioAbbonamento2',
                    component: DettaglioAbbonamento
                },
                {
                    path: 'dettaglioabbonamento/id_socio/:id_socio',
                    name: 'DettaglioAbbonamento1',
                    component: DettaglioAbbonamento
                },
                {
                    path: 'risposte/id_scheda/:id_scheda',
                    name: 'Risposte',
                    component: Risposte
                },
                {
                    path: 'tipologie',
                    name: 'Tipologie',
                    component: Tipologie
                },
                {
                    path: 'pagamenti',
                    name: 'Pagamenti',
                    component: Pagamenti
                },
                {
                    path: 'pagamenti/id_evento/:id_evento',
                    name: 'Pagamenti6',
                    component: Pagamenti
                },
                {
                    path: 'pagamenti/id_socio/:id_socio',
                    name: 'Pagamenti5',
                    component: Pagamenti
                },
                {
                    path: 'pagamenti/id_evento/:id_evento/id_socio/:id_socio',
                    name: 'Pagamenti4',
                    component: Pagamenti
                },
                {
                    path: 'pagamenti/id_evento/:id_evento/id_socio/:id_socio/id_partecipa/:id_partecipa',
                    name: 'Pagamenti3',
                    component: Pagamenti
                },
                {
                    path: 'pagamenti/id_evento/:id_evento/id_socio/:id_socio/id_prenotazione/:id_prenotazione',
                    name: 'Pagamenti2',
                    component: Pagamenti
                },
                {
                    path: 'pagamenti/id_impianto/:id_impianto/id_socio/:id_socio/id_prenotazione/:id_prenotazione',
                    name: 'Pagamenti1',
                    component: Pagamenti
                },
                {
                    path: 'storico/id_socio/:id_socio',
                    name: 'Storico',
                    component: Storico
                },
                {
                    path: 'dettagliocategoria',
                    name: 'DettaglioCategoria',
                    component: DettaglioCategoria
                },
                {
                    path: 'dettagliocategoria/:id',
                    name: 'DettaglioCategoria1',
                    component: DettaglioCategoria
                },
                {
                    path: 'dettaglioconvenzione',
                    name: 'DettaglioConvenzione2',
                    component: DettaglioConvenzione
                },
                {
                    path: 'dettaglioconvenzione/:id',
                    name: 'DettaglioConvenzione1',
                    component: DettaglioConvenzione
                },
                {
                    path: 'dettaglioevento',
                    name: 'DettaglioEvento',
                    component: DettaglioEvento
                },
                {
                    path: 'dettaglioevento/:id',
                    name: 'DettaglioEvento2',
                    component: DettaglioEvento
                },
                {
                    path: 'dettaglioevento/:id/duplica/:duplica',
                    name: 'DettaglioEvento1',
                    component: DettaglioEvento
                },
                {
                    path: 'dettagliovoto/id/:id/id_scheda/:id_scheda/tipo/:tipo',
                    name: 'DettaglioVoto',
                    component: DettaglioVoto
                },
                {
                    path: 'dettagliosocio',
                    name: 'DettaglioSocio',
                    component: DettaglioSocio
                },
                {
                    path: 'dettagliosocio/:id',
                    name: 'DettaglioSocio1',
                    component: DettaglioSocio
                },
                {
                    path: 'dettaglioprenotazione/id_scheda/:id_scheda/tipo/E',
                    name: 'DettaglioPrenotazioneEvento',
                    component: DettaglioPrenotazioneEvento
                },
                {
                    path: 'dettaglioprenotazione/id/:id/id_scheda/:id_scheda/tipo/E',
                    name: 'DettaglioPrenotazioneEvento1',
                    component: DettaglioPrenotazioneEvento
                },
                {
                    path: 'dettaglioprenotazione/id_scheda/:id_scheda/tipo/I',
                    name: 'DettaglioPrenotazioneImpianto',
                    component: DettaglioPrenotazioneImpianto
                },
                {
                    path: 'dettaglioprenotazione/id/:id/id_scheda/:id_scheda/tipo/I',
                    name: 'DettaglioPrenotazioneImpianto1',
                    component: DettaglioPrenotazioneImpianto
                },
                {
                    path: 'dettagliopartecipa/id_scheda/:id_scheda/tipo/:tipo/tipoevento/:tipoevento',
                    name: 'DettaglioPartecipa',
                    component: DettaglioPartecipa
                },
                {
                    path: 'dettagliopartecipa/id/:id/id_scheda/:id_scheda/tipo/:tipo/tipoevento/:tipoevento',
                    name: 'DettaglioPartecipa1',
                    component: DettaglioPartecipa
                },
                {
                    path: 'dettagliopagamento',
                    name: 'DettaglioPagamento',
                    component: DettaglioPagamento
                },
                {
                    path: 'dettagliopagamento/:id',
                    name: 'DettaglioPagamento4',
                    component: DettaglioPagamento
                },
                // {
                //     path: 'dettagliopagamento/id_evento/:id_evento/id_socio/:id_socio',
                //     name: 'DettaglioPagamento',
                //     component: DettaglioPagamento
                // },
                {
                    path: 'dettagliopagamento/id_evento/:id_evento/id_socio/:id_socio/id_partecipa/:id_partecipa',
                    name: 'DettaglioPagamento3',
                    component: DettaglioPagamento
                },
                {
                    path: 'dettagliopagamento/id_evento/:id_evento/id_socio/:id_socio/id_prenotazione/:id_prenotazione',
                    name: 'DettaglioPagamento2',
                    component: DettaglioPagamento
                },
                {
                    path: 'dettagliopagamento/id_socio/:id_socio',
                    name: 'DettaglioPagamento1',
                    component: DettaglioPagamento
                },
                // {
                //     path: 'dettagliopagamento/id_evento/:id_evento',
                //     name: 'DettaglioPagamento',
                //     component: DettaglioPagamento
                // },
                {
                    path: 'dettagliosconto',
                    name: 'DettaglioSconto',
                    component: DettaglioSconto
                },
                {
                    path: 'dettagliosconto/id_scheda/:id_scheda/tipo/:tipo',
                    name: 'DettaglioSconto2',
                    component: DettaglioSconto
                },
                {
                    path: 'dettagliosconto/:id',
                    name: 'DettaglioSconto1',
                    component: DettaglioSconto
                },
                {
                    path: 'dettagliosondaggioopzione/id_scheda/:id_scheda/tipo/:tipo',
                    name: 'DettaglioSondaggioOpzione',
                    component: DettaglioSondaggioOpzione
                },
                {
                    path: 'dettagliosondaggioopzione/id/:id/id_scheda/:id_scheda/tipo/:tipo',
                    name: 'DettaglioSondaggioOpzione1',
                    component: DettaglioSondaggioOpzione
                },
                {
                    path: 'dettagliodocumento',
                    name: 'DettaglioDocumento2',
                    component: DettaglioDocumento
                },
                {
                    path: 'dettagliodocumento/:id',
                    name: 'DettaglioDocumento1',
                    component: DettaglioDocumento
                },
                {
                    path: 'dettagliomodulistica',
                    name: 'DettaglioModulistica',
                    component: DettaglioModulistica
                },
                {
                    path: 'dettagliomodulistica/:id',
                    name: 'DettaglioModulistica1',
                    component: DettaglioModulistica
                },
                {
                    path: 'dettaglioimpianto',
                    name: 'DettaglioImpianto',
                    component: DettaglioImpianto
                },
                {
                    path: 'dettaglioimpianto/:id',
                    name: 'DettaglioImpianto2',
                    component: DettaglioImpianto
                },
                {
                    path: 'dettaglioimpianto/:id/duplica/:duplica',
                    name: 'DettaglioImpianto1',
                    component: DettaglioImpianto
                },
                {
                    path: 'dettagliodocumento/id_socio/:id_socio',
                    name: 'DettaglioDocumento',
                    component: DettaglioDocumento
                },
                {
                    path: 'testataquestionario',
                    name: 'TestataQuestionario',
                    component: TestataQuestionario
                },
                {
                    path: 'testataquestionario/:id',
                    name: 'TestataQuestionario1',
                    component: TestataQuestionario
                },
                {
                    path: 'dettaglioquestionario',
                    name: 'DettaglioQuestionario',
                    component: DettaglioQuestionario
                },
                {
                    path: 'dettaglioquestionario/:id',
                    name: 'DettaglioQuestionario1',
                    component: DettaglioQuestionario
                },
                {
                    path: 'dettagliodomanda/:id',
                    name: 'dettagliodomanda',
                    component: DettaglioDomanda
                },
                {
                    path: 'dettagliodomanda/id_questionariodomande/:id_questionariodomande',
                    name: 'dettagliodomanda1',
                    component: DettaglioDomanda
                },
                {
                    path: 'dettagliotipologia',
                    name: 'DettaglioTipologia',
                    component: DettaglioTipologia
                },
                {
                    path: 'dettagliotipologia/:id',
                    name: 'DettaglioTipologia1',
                    component: DettaglioTipologia
                },
                {
                    path: 'dettagliorisposta',
                    name: 'DettaglioRisposta',
                    component: DettaglioRisposta
                },
                {
                    path: 'dettagliorisposta/id/:id/titolo/:titolo',
                    name: 'DettaglioRisposta1',
                    component: DettaglioRisposta
                },
                {
                    path: 'analisirisultati',
                    name: 'AnalisiRisultati',
                    component: AnalisiRisultati
                },
                {
                    path: 'analisirisultati/id_scheda/:id_scheda/tipo/:tipo/titolo/:titolo',
                    name: 'AnalisiRisultati1',
                    component: AnalisiRisultati
                },
                {
                    path: 'parenti/id_socio/:id_socio',
                    name: 'Parenti',
                    component: Parenti
                },
                {
                    path: 'dettaglioparente/:id',
                    name: 'DettaglioParente',
                    component: DettaglioParente
                },
                {
                    path: 'dettaglioparente/id_socio/:id_socio',
                    name: 'DettaglioParente1',
                    component: DettaglioParente
                },
                {
                    path: 'push',
                    name: 'Push',
                    component: Push
                },
                {
                    path: 'push/id_scheda/:id_scheda/tipo/:tipo/titolo/:titolo',
                    name: 'Push1',
                    component: Push
                },
                {
                    path: 'parametri',
                    name: 'Parametri',
                    component: Parametri
                },
                {
                    path: 'news',
                    name: 'News ',
                    component: News
                },
                {
                    path: 'news/filter/:filter/datainizio/:datainizio/datafine/:datafine',
                    name: 'News1',
                    component: News
                },
                {
                    path: 'news/datainizio/:datainizio/datafine/:datafine',
                    name: 'News2',
                    component: News
                },
                {
                    path: 'dettaglionews',
                    name: 'DettaglioNews',
                    component: DettaglioNews
                },
                {
                    path: 'dettaglionews/:id',
                    name: 'DettaglioNews1',
                    component: DettaglioNews
                },
                {
                    path: 'bacheca',
                    name: 'Bacheca ',
                    component: Bacheca
                },
                {
                    path: 'bacheca/filter/:filter/datainizio/:datainizio/datafine/:datafine',
                    name: 'Bacheca1',
                    component: Bacheca
                },
                {
                    path: 'bacheca/datainizio/:datainizio/datafine/:datafine',
                    name: 'Bacheca2',
                    component: Bacheca
                },
                {
                    path: 'dettagliobacheca',
                    name: 'DettaglioBacheca',
                    component: DettaglioBacheca
                },
                {
                    path: 'dettagliobacheca/:id',
                    name: 'DettaglioBacheca1',
                    component: DettaglioBacheca
                },
                {
                    path: 'partecipa/id/:id/tipo/:tipo',
                    name: 'Partecipa',
                    component: Partecipa
                },
                {
                    path: 'partecipa/id/:id/tipo/:tipo/tipoevento/:tipoevento',
                    name: 'Partecipa1',
                    component: Partecipa
                },
                {
                    path: 'prenotazioni/id/:id/tipo/:tipo',
                    name: 'Prenotazioni',
                    component: Prenotazioni
                },
                {
                    path: 'prenotazioni/id/:id/tipo/:tipo/datainizio/:datainizio/datafine/:datafine',
                    name: 'Prenotazioni1',
                    component: Prenotazioni
                },
                {
                    path: 'prenotazioni',
                    name: 'Prenotazioni2',
                    component: Prenotazioni
                },
                {
                    path: 'prenotazioni/tipo/:tipo',
                    name: 'Prenotazioni3',
                    component: Prenotazioni
                },
                {
                    path: 'prenotazioni/tipo/:tipo/datainizio/:datainizio/datafine/:datafine',
                    name: 'Prenotazioni4',
                    component: Prenotazioni
                },
                {
                    path: 'sondaggioopzioni/id/:id/tipo/:tipo',
                    name: 'SondaggioOpzioni',
                    component: SondaggioOpzioni
                },
                {
                    path: 'sondaggiorisposte/id_scheda/:id_scheda/tipo/:tipo/id_sondaggioopzione/:id_sondaggioopzione',
                    name: 'SondaggioRisposte',
                    component: SondaggioRisposte
                },
                {
                    path: 'sondaggiorisposte/id_scheda/:id_scheda/tipo/:tipo',
                    name: 'SondaggioRisposte2',
                    component: SondaggioRisposte
                },
                {
                    path: 'orari/:id',
                    name: 'Orari1',
                    component: Orari
                },
                {
                    path: 'dettaglioorario/:id',
                    name: 'DettaglioOrario',
                    component: DettaglioOrario
                },
                {
                    path: 'dettaglioorario/:id/duplica/:duplica',
                    name: 'DettaglioOrario1',
                    component: DettaglioOrario
                },
                {
                    path: 'dettaglioorario/id_scheda/:id_scheda/tipo/:tipo',
                    name: 'DettaglioOrario2',
                    component: DettaglioOrario
                },
                // {
                //     path: 'calendarioimpianto/id_scheda/:id_scheda/tipo/:tipo/data/:data/id_socio/:id_socio',
                //     name: 'CalendarioImpianto',
                //     component: CalendarioImpianto
                // }
            ]
        },
        {
            path: '*',
            component: PageNotFound
        }
    ]
})



router.beforeEach((to, from, next) => {
    // alert('to: ' + JSON.stringify(to))
    if (to.path !== '/' &&
        !to.path.startsWith('/autoiscrizione') &&
        !to.path.startsWith('/loginfromapp') &&
        !to.path.startsWith('/loginutenti')
    ) {

        var isUtente = false;
        if (to.path.startsWith('/ute/') || to.path == '/ute') {
            isUtente = true;
        }

        if ((localStorage.getItem('token') || '') === '') {
            (isUtente ? router.push('/loginutenti') : router.push('/'))
            //router.push('/')
        } else {

            var token = localStorage.getItem('token')
            axios.get(NAMESPACE + 'rest/logged', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {
                        if (!response.data.error) {
                            if (response.data.token != null) {
                                localStorage.setItem('token', response.data.token)
                                next()
                            } else {
                                (isUtente ? router.push('/loginutenti') : router.push('/'))
                            }
                        } else {
                            // non loggato
                            (isUtente ? router.push('/loginutenti') : router.push('/'))
                        }
                    } catch (e) {
                        (isUtente ? router.push('/loginutenti') : router.push('/'))
                    }
                })
                .catch(e => {
                    (isUtente ? router.push('/loginutenti') : router.push('/'))
                    e // così non da errore
                })
        }
    } else {
        next()
    }
})



new Vue({
    router,
    render: h => h(App),
}).$mount('#app')

// new Vue({
//     el: '#app',
//     router,
//     template: '<App/>',
//     components: {
//         App
//     }
// })
